import {AlertFillIcon} from '@primer/octicons-react'
import {ForYouItem} from '../shared/ForYouItem'
import {ForYouLeadingIcon} from '../shared/ForYouLeadingIcon'
import {PendingChecksBody} from './shared/PendingChecksBody'
import {decideChecksItem} from './shared/checks-item-decider'
import {useMergeabilityData} from './use-mergeability-data'
import {WorkflowApprovalSubtitle} from '@github-ui/mergebox/components/sections/checks/WorkflowApprovalSubtitle'
import {checksSectionHeading} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'
import {usePullRequestAnalytics} from '../../../../hooks/use-pull-request-analytics'
import styles from '../shared/ForYouItem.module.css'

// Renders when workflow runs are awaiting approval but the viewer cannot approve them.
// Shows the approval message without the approve action.
export function AwaitingApprovalChecks({variant}: {variant?: 'default' | 'embedded'}) {
  const data = useMergeabilityData()
  const {sendPullRequestAnalyticsEvent} = usePullRequestAnalytics()

  const decision = decideChecksItem(data)
  if (!data || decision.kind !== 'awaiting-approval') {
    return null
  }

  const {checksSection} = data
  const {workflowApproval} = decision

  return (
    <ForYouItem
      leadingVisual={<ForYouLeadingIcon icon={AlertFillIcon} variant="warning" />}
      title={checksSectionHeading[checksSection.sectionStatus]}
      itemName="pending-checks"
      padding="none"
      variant={variant}
      description={
        <WorkflowApprovalSubtitle
          pendingWorkflowApprovalRollup={workflowApproval}
          className={styles.description}
          onClick={() =>
            sendPullRequestAnalyticsEvent('overview.for_you_item_action', 'OVERVIEW_FOR_YOU_ITEM', {
              item_name: 'pending-checks',
              action_name: 'learn_about_approving_workflows',
            })
          }
        />
      }
    >
      <PendingChecksBody
        data={data}
        itemName="pending-checks"
        emptyMessage="Workflow runs are awaiting approval. Check results will appear once the workflows begin running."
      />
    </ForYouItem>
  )
}
